import { window } from 'rxjs/operators';

import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router'
import { Console } from '@angular/core/src/console';

import { ExibirMenuService } from '../shared/exibir-menu.service'
import { AcessoApiService } from '../../acessoApi.service'
import { DadosAcessoService } from '../../dadosAcesso.service';
import { NotificationsService } from 'angular2-notifications';
import { Usuario } from "./usuario.model"
import { tokenModel } from './token.model'
import { HttpErrorResponse } from '@angular/common/http/src/response';
import { TextMaskModule } from 'angular2-text-mask';


declare var $: any

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  public mostraMenu: boolean = true
  public dadosAcesso: any

  public senha: string = '';
  public login: string = '';
  public nome_pessoa: string = '';
  public fantasia_nome: string = '';
  public cod_loja: string = '';
  public id_oper: number;
  public textoBotao: string = "Entrar"

  public Cod_lojaReset: string
  public cnpj: string
  public ExibirBotaoEditar: boolean
  public isNotCacau: boolean
  public exibirCadOper: boolean

  // public token: any
  // public access_token: string = "mQeuYcKa-VCt3RguLtHSHLKj_kesE9OqZQryLg3BqzaMedBUc39JY47MnDSLEmlglxx9TaWd81w4xAPO5GrUkZbhuzyUFyQHIKw-LX8v0MMx-PI_8AZY8SJ3tkUMnlBz5QBmdQQhN4pCHdDvLqoxHaRRyWdbflR5lP2YrgeUcJnCxOfMxnnBjTaCKJkD-wcOI0P1PysO6-Bi0cCZvCQbwgc3m7_Zi4Zq7lY6sY41c_J98Sfd0ihmAStx5fROFRy7hwDGhpxn8j5DsOyCITHsm_RV_hxNlYhGI111CzPOngNpP9Mm9SaCuIN-_iP5yr-J"
  // public token_type: string
  // public expires_in: number

  // public testeToken: tokenModel[] = [{
  //   access_token: this.access_token,
  //   token_type: this.token_type,
  //   expires_in: this.expires_in
  // }]

  public DadosAcesso: Usuario[] = [{
    nome_pessoa: this.nome_pessoa,
    fantasia_nome: this.fantasia_nome,
    cod_loja: this.cod_loja,
    id_oper: this.id_oper,
    exibirEditar: this.ExibirBotaoEditar,
    exibirCadOper: this.exibirCadOper

  }];

  @Output() public dadosUsuario: EventEmitter<Usuario[]> = new EventEmitter()

  public options = {
    position: ["bottom", "right"],
    timeOut: 5000,
    lastOnBottom: true

  }


  public maskCnpj = [/[0-9]/, /\d/,'.', /\d/, /\d/, /\d/,'.', /\d/,/\d/,/\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/ ]


  constructor(private _router: Router, private exibeMenu: ExibirMenuService, private acessoAPI: AcessoApiService, private dadosAcessoService: DadosAcessoService, private notificacao: NotificationsService) {
    this.exibeMenu.setItensVisiveis(false);
  }



  ngOnInit() {

  }



  getLogin(login: Event): void {
    this.login = (<HTMLInputElement>login.target).value;
  }

  getSenha(senha: Event): void {
    this.senha = (<HTMLInputElement>senha.target).value;
  }

  // Token(){
  //   debugger
  //   this.acessoAPI.getToken(this.login, this.senha).subscribe(
  //     data =>{
  //       debugger
  //          this.access_token = data.access_token
  //          this.token_type = data.token_type
  //     }, (error: HttpErrorResponse) =>{
  //     }
  //   )

  // }

  resetarSenha(){
    this.acessoAPI.resetarComCnpj(this.Cod_lojaReset, this.cnpj).subscribe(data =>{

      this.notificacao.success(
        'Sucesso!',
        'Senha resetada com sucesso',
        {
          timeOut: 2000,
          showProgressBar: false,
          pauseOnHover: false,
          clickToClose: false,
          maxLength: 2
        }
      )

      $("#modalEsqueciSenha").modal('hide');

    }, (error: any ) =>{

      this.notificacao.error(
        'Falha de Autenticação!',
       JSON.stringify(error._body) ,
        {
          timeOut: 2000,
          showProgressBar: false,
          pauseOnHover: false,
          clickToClose: false,
          maxLength: 2
        }
      )

    })
  }

  validarLogin(): void {
    this.textoBotao = "Entrando..."
    $('#esqueciSenha').prop('enabled',true)
    $('#loginEntrar').prop('enabled',true)

    this.acessoAPI.PostLogin(this.login, this.senha)
      .subscribe(
      data => {


        this.dadosAcesso = data
        sessionStorage.setItem('nome_pessoa', this.dadosAcesso[0].Nome_pessoa)
        sessionStorage.setItem('fantasia_nome', this.dadosAcesso[0].Fantasia_nome)
        sessionStorage.setItem('cnpj', this.dadosAcesso[0].Cnpj)
        sessionStorage.setItem('cod_loja',this.dadosAcesso[0].Cod_loja)
        sessionStorage.setItem('id_oper',this.dadosAcesso[0].Id_oper)
        sessionStorage.setItem('ExibirBotaoEditar', this.dadosAcesso[0].exibir_botoes)
        sessionStorage.setItem('exibirCadOper', this.dadosAcesso[0].existe_oper)
        sessionStorage.setItem('isNotCacau', this.dadosAcesso[0].isNotCacau)
        sessionStorage.setItem('nome_completo', this.dadosAcesso[0].Nome_completo)
        sessionStorage.setItem('endereco', this.dadosAcesso[0].Endereco)
        sessionStorage.setItem('bairro', this.dadosAcesso[0].Bairro)
        sessionStorage.setItem('cidade', this.dadosAcesso[0].Cidade)
        sessionStorage.setItem('uf', this.dadosAcesso[0].Uf)

        this.DadosAcesso = [{
          nome_pessoa: this.dadosAcesso[0].Nome_pessoa, fantasia_nome: this.dadosAcesso[0].Fantasia_nome, cod_loja: this.dadosAcesso[0].Cod_loja, id_oper: this.dadosAcesso[0].Id_oper, exibirEditar: this.ExibirBotaoEditar,exibirCadOper: this.exibirCadOper
        }]

        this.dadosAcessoService.criarNovoAcesso(this.DadosAcesso)

        this.textoBotao = "Entrar"

        this._router.navigate(["/home"])

      },
      error => {
        this.textoBotao = "Entrar"

        this.notificacao.error(
          'Falha de Autenticação!',
          'Favor verificar seu usuário e senha',
          {
            timeOut: 2000,
            showProgressBar: false,
            pauseOnHover: false,
            clickToClose: false,
            maxLength: 2
          }
        )
      });
  }

}





// WEBPACK FOOTER //
// ./src/app/pages/login/login.component.ts